import { gql } from '@apollo/client';

const COMPANY_FRAGMENT = gql`
  fragment HeaderCompany on Company {
    __typename
    type
    ... on PrivateCompany {
      id
      name
    }
    ... on UserCompany {
      id
      name
    }
  }
`;

const PoolHeaderFragments = {
  listing: gql`
    fragment PoolHeaderListing on Listing {
      __typename
      id
      name
      assetClass: asset_class
      description
      createdDate: created_date
      seller: company {
        ...HeaderCompany
      }
      in_progress_deal_id
    }
    ${COMPANY_FRAGMENT}
  `,
  deal: gql`
    fragment PoolHeaderDeal on Deal {
      id
      createdDate: created_date
      buyer {
        ...HeaderCompany
      }
      seller {
        ...HeaderCompany
      }
    }
    ${COMPANY_FRAGMENT}
  `,
};

export { PoolHeaderFragments };
